import get from "lodash/get";
import { colorModes } from "../props/colors";
import fontFamily from "../props/fontFamily";
import { fontSizes } from "../props/textStyles";
import radii from "../props/radii";
import breakpoints from "../props/breakpoints";
import { zIndexTokens } from "../props/zIndexes";
import * as buttonPaintMap from "../props/buttonPaintMap";

const props = {
  colors: colorModes,
  fontFamily,
  fontSize: fontSizes,
  radii,
  breakpoints,
  zIndexes: zIndexTokens,
  buttonPaintMap,
};

/**
 * Get a specific theme property.
 */
export default function theme(
  key: string,
  fallback: string | string[] | null = null
): string | string[] | null {
  return get(props, key, fallback);
}
